<template>
    <div
        class="col-span-full grid-cols-subgrid gap-x-3 grid items-center min-w-0 justify-end lg:col-span-1"
        role="cell"
    >
        <div class="block text-xs text-slate-500 lg:hidden" :class="[props.labelClasses]">
            <slot name="label"></slot>
        </div>
        <div class="text-sm flex items-center max-w-full min-w-0" :class="[props.contentClasses]">
            <!-- Padded so the clip leaves room for a cell button's focus ring. -->
            <span class="truncate min-w-0 p-1 -m-1">
                <slot></slot>
            </span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    labelClasses: {
        type: String,
        default: '',
    },
    contentClasses: {
        type: String,
        default: '',
    },
});
</script>
